export { default } from './logout-button'
